<template>
    <StyleCarouselProducts>
        <div
            class="carousel-products owl-carousel owl-theme custom-carousel-one"
            :id="`carousel-products-${sessionName}`"
        >
            <div
                class="item"
                id="item"
                style="margin:0.2rem"
                v-for="(product, index) in products"
                :key="index"
                :data-index="index"
            >
                <ProductDefault
                    :key="product.id"
                    layout_mode="list"
                    :pro="product"
                    :products_settings="company.products_settings"
                    :carousel_products="true"
                />
            </div>
        </div>
    </StyleCarouselProducts>
</template>

<script>
import ProductDefault from "../product/ProductDefault.vue";
import { StyleCarouselProducts } from "./style";
export default {
    name: "CarouselProducts",
    components: {
        ProductDefault,
        StyleCarouselProducts
    },
    props: {
        products: {
            type: Array,
            required: true
        },
        sessionName: {
            type: String,
            required: true // Identificador único para o carousel
        }
    },
    data() {
        return {
            company: this.$root.$children[0].$attrs.company,
            quantity_products: this.$root.$children[0].theme?.carousel_products?.quantity_products ?? 6,
            carousel_loop: this.$root.$children[0].theme?.carousel_products?.active_carousel_loop ?? false
        };
    },
    mounted() {
        this.initializeCarousel();
        this.setAriaLabels();
    },
    methods: {
        initializeCarousel() {
            $(document).ready(() => {
                $(`#carousel-products-${this.sessionName}`).owlCarousel({
                    loop: false,
                    rewind: this.carousel_loop,
                    autoplay: this.carousel_loop,
                    autoplayTimeout: 6000,
                    nav: true,
                    dots: false,
                    navText: [
                        "<div class='custom-nav-product prev'><i class='fas fa-angle-left' style='font-size: 16px'></i></div>",
                        "<div class='custom-nav-product next'><i class='fas fa-angle-right' style='font-size: 16px'></i></div>"
                    ],
                    responsive: {
                        0: {
                            items: 1
                        },
                        400: {
                            items: 2
                        },
                        600: {
                            items: 3
                        },
                        1000: {
                            items: this.quantity_products
                        }
                    }
                });
            });
        },
        setAriaLabels() {
            this.$nextTick(() => {
                let buttonPrev = document.querySelectorAll("button.owl-prev");
                let buttonNext = document.querySelectorAll("button.owl-next");

                for (const button of buttonPrev) {
                    button.setAttribute("aria-label", "Banner anterior");
                }
                for (const button of buttonNext) {
                    button.setAttribute("aria-label", "Próximo banner");
                }
            });
        }
    }
};
</script>

<style></style>
